import { render, staticRenderFns } from "./presentationLottery.vue?vue&type=template&id=47380d6c&"
import script from "./presentationLottery.vue?vue&type=script&lang=js&"
export * from "./presentationLottery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports